import { SegmentedControl } from '@mantine/core';

export type ViewMode = 'ViewAll' | 'ViewAdvised' | 'ViewNonAdvised';

interface FilterRowProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export function FilterRow({ viewMode, setViewMode }: FilterRowProps) {
  return (
    <SegmentedControl
      value={viewMode}
      onChange={(value) => setViewMode(value as ViewMode)}
      data={[
        { label: 'View All', value: 'ViewAll' },
        { label: 'View Advised', value: 'ViewAdvised' },
        { label: 'View Non-Advised', value: 'ViewNonAdvised' },
      ]}
    />
  );
}
